module.exports = __webpack_public_path__ + "img/clients.ed8aa6da.svg";